import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { getBytesFromMetaplexFiles, useMetaplexFileFromJson, useMetaplexFile } from './MetaplexFile.mjs';
import { DriverNotProvidedError, InvalidJsonStringError } from '../../errors/SdkError.mjs';

class StorageClient {
  constructor() {
    _defineProperty(this, "_driver", null);
  }

  driver() {
    if (!this._driver) {
      throw new DriverNotProvidedError('StorageDriver');
    }

    return this._driver;
  }

  setDriver(newDriver) {
    this._driver = newDriver;
  }

  getUploadPriceForBytes(bytes) {
    return this.driver().getUploadPrice(bytes);
  }

  getUploadPriceForFile(file) {
    return this.getUploadPriceForFiles([file]);
  }

  getUploadPriceForFiles(files) {
    return this.getUploadPriceForBytes(getBytesFromMetaplexFiles(...files));
  }

  upload(file) {
    return this.driver().upload(file);
  }

  uploadAll(files) {
    const driver = this.driver();
    return driver.uploadAll ? driver.uploadAll(files) : Promise.all(files.map(file => this.driver().upload(file)));
  }

  uploadJson(json) {
    return this.upload(useMetaplexFileFromJson(json));
  }

  async download(uri, options) {
    const driver = this.driver();

    if (driver.download) {
      return driver.download(uri, options);
    }

    const response = await fetch(uri, options);
    const buffer = await response.arrayBuffer();
    return useMetaplexFile(buffer, uri);
  }

  async downloadJson(uri, options) {
    const file = await this.download(uri, options);

    try {
      return JSON.parse(file.buffer.toString());
    } catch (error) {
      throw new InvalidJsonStringError(error);
    }
  }

}

export { StorageClient };
//# sourceMappingURL=StorageClient.mjs.map
